export default __webpack_public_path__ + "static/media/M38.4b6b0dd5.svg";